import { query } from '../utilities';

export const cashbackOrderSave = (data) => {
    return query('/order/cashback-order-save/', {data});
};
